import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
    selectRegistrationsFromRegistration,
    updateRegistration,
    updateRegistrationClassification,
} from "../../redux/slices/registrationSlice";
import {
    selectAllP2pSettings,
    selectBaseUrl,
} from "../../redux/slices/p2pSettingsSlice";
import { selectTeamById } from "../../redux/slices/teamsSlice";
import { selectAllClassifications } from "../../redux/slices/classificationsSlice";
import PreselectTeam from "./PreselectTeam";

const ConnectedPreselectTeam = () => {
    const { teamId } = useParams();
    const registrations = useSelector(selectRegistrationsFromRegistration);
    const classifications = useSelector(selectAllClassifications);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { limitTeamJoiningToClassification } = p2pSettings;

    const primaryRegistration = registrations[0]
        ? registrations[0]
        : {
              Team: "",
          };

    const { Team } = primaryRegistration;
    let hasActiveClassificationAssociatedWithTeamAndShouldBeLimited = false;
    // This should be set to false if the classification the team must be limited
    // to is no longer available
    let teamShouldBeSet = true;

    const team = useSelector((state) => selectTeamById(state, teamId));
    const classificationIdForPreselectedTeam = team?.classification || "";

    if (classificationIdForPreselectedTeam && classifications.length > 0) {
        const teamClassificationData =
            classifications?.find(
                (classification) =>
                    Number(classification.id) ===
                    Number(classificationIdForPreselectedTeam),
            ) || {};

        if (
            Object.keys(teamClassificationData)?.length === 0 &&
            limitTeamJoiningToClassification
        ) {
            teamShouldBeSet = false;
        }

        if (
            Object.keys(teamClassificationData)?.length > 0 &&
            limitTeamJoiningToClassification
        ) {
            hasActiveClassificationAssociatedWithTeamAndShouldBeLimited = true;
        }
    }

    const baseUrl = useSelector(selectBaseUrl);
    const preselectTeamProps = {
        baseUrl,
        Team,
        teamId,
        updateRegistration,
        hasActiveClassificationAssociatedWithTeamAndShouldBeLimited,
        classificationIdForPreselectedTeam,
        updateRegistrationClassification,
        teamShouldBeSet,
    };
    return <PreselectTeam {...preselectTeamProps} />;
};

export default ConnectedPreselectTeam;
